import React, { JSX } from 'react'
import { ClockIcon } from '@heroicons/react/24/outline'
import { PollDraft, PollLiveData, PollPreview } from 'components/PollPreview'
import { ScaledStage } from 'components/ScaledStage'
import { POLL } from 'lib/elementCanvas'
import { PUBLIC_HOME_COPY as COPY } from 'lib/publicHomeCopy'
import { SOON_POLL_STYLE, SOON_POLL_VOTES } from 'components/publicHome/publicHomeSamples'

const CHIP_CLASSES = 'inline-block rounded-full bg-dm-bg-accent/50 px-2.5 py-0.5 text-[10px] font-semibold uppercase tracking-wider text-dm-text-accent ring-1 ring-inset ring-white/10'

const SOON_POLL_DRAFT: PollDraft = {
  name: '',
  question: COPY.soon.poll.question,
  callToActionText: COPY.soon.poll.callToAction,
  options: COPY.soon.poll.options.map(({ displayText, command }) => ({
    displayText,
    command,
    textColor: SOON_POLL_STYLE.optionTextColor,
    progressBarColor: SOON_POLL_STYLE.optionProgressColor,
    backgroundColor: ''
  })),
  template: 'CLASSIC',
  tickerLabel: '',
  ctaSubtext: '',
  tickerTextSize: 'MEDIUM',
  tickerBlockWeights: null,
  headingTextColor: SOON_POLL_STYLE.headingTextColor,
  headingBackground: SOON_POLL_STYLE.headingBackground,
  optionsTextColor: SOON_POLL_STYLE.optionsTextColor,
  optionsBackground: SOON_POLL_STYLE.optionsBackground,
  callToActionTextColor: SOON_POLL_STYLE.callToActionTextColor,
  callToActionBackground: SOON_POLL_STYLE.callToActionBackground,
  alternatingOptionBackground: SOON_POLL_STYLE.optionsBackground,
  backgroundImage: '',
  backgroundImageFit: 'COVER',
  cornerRadius: SOON_POLL_STYLE.cornerRadius,
  borderWidth: SOON_POLL_STYLE.borderWidth,
  borderColor: SOON_POLL_STYLE.borderColor,
  winnerOutlineColor: SOON_POLL_STYLE.winnerOutlineColor,
  fontKey: 'DEFAULT'
}

const SOON_POLL_LIVE: PollLiveData = {
  totalVotes: SOON_POLL_VOTES.reduce((sum, n) => sum + n, 0),
  optionVoteCounts: [...SOON_POLL_VOTES],
  votingClosed: false
}

export const ComingSoonStrip = ({ withPoll }: { withPoll: boolean }): JSX.Element => (
  <section aria-labelledby='public-home-soon' className='py-16 sm:py-24'>
    <div className='mx-auto w-full max-w-6xl px-4 sm:px-6'>
      <div className='mx-auto max-w-2xl text-center'>
        <span className={CHIP_CLASSES}>{COPY.soon.chip}</span>
        <h2
          id='public-home-soon'
          className='mt-3 text-[28px] font-semibold leading-8 text-dm-text-primary sm:text-[34px] sm:leading-10'
        >
          {COPY.soon.heading}
        </h2>
      </div>
      <ul className='mx-auto mt-10 grid max-w-4xl gap-x-8 gap-y-4 sm:grid-cols-2'>
        {COPY.soon.items.map((text) => (
          <li key={text} className='flex items-start gap-3'>
            <ClockIcon className='mt-0.5 size-5 shrink-0 text-dm-text-accent' aria-hidden='true' />
            <span className='text-[15px] leading-6 text-dm-text-secondary sm:text-base sm:leading-[26px]'>{text}</span>
          </li>
        ))}
      </ul>
      {withPoll && (
        <figure className='mx-auto mt-10 w-full max-w-md'>
          <div aria-hidden='true'>
            <ScaledStage mode='preview' elementWidth={POLL.width}>
              <PollPreview draft={SOON_POLL_DRAFT} live={SOON_POLL_LIVE} />
            </ScaledStage>
          </div>
          <figcaption className='mt-3 text-center'>
            <span className={CHIP_CLASSES}>{COPY.soon.chip}</span>
          </figcaption>
        </figure>
      )}
    </div>
  </section>
)
